module.exports = __webpack_public_path__ + "media/images/application2/Payments__card__right__top--caret-f9984eb79dc6120d2716494014a46752.svg";